(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halo-custom-information-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('burchda-assurance')) {
    class BurchdaAssurance extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-assurance-trigger]');
          if (!trigger || !this.contains(trigger)) return;

          const wasOpen = trigger.getAttribute('aria-expanded') === 'true';

          this.querySelectorAll('[data-assurance-trigger]').forEach((button) => {
            button.setAttribute('aria-expanded', 'false');
          });

          this.querySelectorAll('[data-assurance-panel]').forEach((panel) => {
            panel.hidden = true;
          });

          if (!wasOpen) {
            const panel = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
            trigger.setAttribute('aria-expanded', 'true');
            if (panel) panel.hidden = false;
          }
        });
      }
    }

    customElements.define('burchda-assurance', BurchdaAssurance);
  }
  } catch(e) { console.error(e); }
})();

})();
